<template>
  <div>
    <vs-button
      style="border-radius: 5px"
      type="gradient"
      color="#02a66d"
      gradient-color-secondary="rgb(1, 52, 74)"
      @click="lojistikSiparisKayit()"
      id="button-with-loading-lojistik"
      class="vs-con-loading__container"
      >Lojistik Siparişi Kaydet</vs-button
    >
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
export default {
  props: ["program"],
  data() {
    return {
      backgroundLoading: "danger",
      colorLoading: "#fff",
      secilenSiparisList: [],
    };
  },
  methods: {
    sepetSecilen(item) {
      console.log(item);
      this.secilenSiparisList = item;
    },
    lojistikSiparisKayit() {
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-lojistik",
        scale: 0.45,
      });

      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenSiparisList.length == 0) {
        vs.notify({
          title: "Lojistik",
          text: "Seçim yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        vm.secilenSiparisList.forEach((val, index) => {
          const args = {
            program: vm.program,
            orderNumber: val.orderNumber,
            token: Store.state.tokenId,
          };
          console.log(args);

          soap.createClient(url, function (err, client) {
            client.siparisYaz(args, function (err, result) {
              if (result.siparisYazResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              console.log(result);
              try {
                vm.veriler = JSON.parse(result.siparisYazResult);
                if (vm.veriler.response == "Bitti") {
                  vs.loading.close(
                    "#button-with-loading-lojistik > .con-vs-loading"
                  );
                  vs.notify({
                    title: "Lojistik",
                    text: "Lojistiğe Gönderildi",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                } else {
                  vs.loading.close(
                    "#button-with-loading-lojistik > .con-vs-loading"
                  );
                  vs.notify({
                    title: "Lojistik",
                    text: "Gönderilemedi",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    position: "top-center",
                  });
                }
              } catch (error) {
                vs.loading.close(
                  "#button-with-loading-lojistik > .con-vs-loading"
                );
                vs.notify({
                  title: "Lojistik",
                  text: "Gönderilemedi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        });
      }
    },
  },
};
</script>
